import React from 'react'
import Link from '@mui/material/Link'

const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g

export function parseMarkdownLinks(text) {
  if (!text) return null

  const matches = Array.from(text.matchAll(LINK_PATTERN))

  if (matches.length === 0) return [text]

  const parts = []
  let lastIndex = 0

  for (const match of matches) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    parts.push(
      <Link
        key={match.index}
        variant="caption"
        href={match[2]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {match[1]}
      </Link>
    )
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}
